"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsOfServiceModalContent = exports.TermsOfServiceModal = void 0;
const react_1 = __importStar(require("react"));
const pactsafe_react_sdk_1 = require("@pactsafe/pactsafe-react-sdk");
const components_1 = require("../../components");
const react_query_1 = require("@tanstack/react-query");
const utils_1 = require("./utils");
const queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 7200000,
        },
    },
});
const TermsOfServiceModal = ({ customData, disabled, groupKey, onDisplayed, onError, onSuccess, signerId, testMode, accessId, }) => (react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
    react_1.default.createElement(exports.TermsOfServiceModalContent, { customData: customData, disabled: disabled, groupKey: groupKey, onDisplayed: onDisplayed, onError: onError, onSuccess: onSuccess, signerId: signerId, testMode: testMode, accessId: accessId })));
exports.TermsOfServiceModal = TermsOfServiceModal;
const TermsOfServiceModalContent = ({ customData, disabled, groupKey, onDisplayed, onError, onSuccess, signerId, testMode, accessId, }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [touched, setTouched] = (0, react_1.useState)(false);
    const { data: numberOfUnsignedContracts, refetch } = (0, react_query_1.useQuery)(['termsOfService', signerId], async () => {
        const numberOfUnsignedContracts = await (0, utils_1.getNumberOfUnsignedContracts)({ accessId, signerId, groupKey });
        return numberOfUnsignedContracts;
    }, {
        enabled: !disabled,
    });
    (0, react_1.useEffect)(() => {
        if (numberOfUnsignedContracts) {
            setOpen(true);
            setTouched(false);
        }
        else {
            setOpen(false);
            if (touched) {
                onSuccess?.();
                setTouched(false);
            }
        }
    }, [numberOfUnsignedContracts]);
    const handleSuccess = async (event_type) => {
        if (event_type === 'agreed') {
            refetch();
            setTouched(true);
        }
    };
    return (react_1.default.createElement(components_1.Dialog, { open: open, fullWidth: true, maxWidth: "md", content: react_1.default.createElement(pactsafe_react_sdk_1.PSClickWrap, { customData: customData, clickWrapStyle: "scroll", accessId: accessId, groupKey: groupKey, signerId: signerId, testMode: testMode, allowDisagreed: true, onDisplayed: onDisplayed, onSent: handleSuccess, onError: (message) => {
                setOpen(false);
                if (onError) {
                    onError(message);
                }
            } }) }));
};
exports.TermsOfServiceModalContent = TermsOfServiceModalContent;
exports.default = exports.TermsOfServiceModal;
